import React from 'react';

const SmartContext = React.createContext();

export default SmartContext;
